import { render, staticRenderFns } from "./HubAdvisoryDirectPayoutSettings.vue?vue&type=template&id=404f5e11&scoped=true"
import script from "./HubAdvisoryDirectPayoutSettings.vue?vue&type=script&lang=js"
export * from "./HubAdvisoryDirectPayoutSettings.vue?vue&type=script&lang=js"
import style0 from "./HubAdvisoryDirectPayoutSettings.vue?vue&type=style&index=0&id=404f5e11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f5e11",
  null
  
)

export default component.exports